import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

/**
 * FR57: reachable from the topbar user menu. Deliberately minimal (a single link) — theme,
 * language, and logout stay exactly where they already are in the topbar; this only adds
 * the missing path to "Mijn gegevens" without restructuring the rest of the topbar.
 */
export function AccountMenu({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();

  return (
    <div
      data-testid="account-menu"
      role="menu"
      aria-label={t('nav.myAccount')}
      className="absolute right-0 top-10 w-48 rounded-lg border p-1 shadow-lg"
      style={{
        backgroundColor: 'var(--background)',
        borderColor: 'var(--border)',
        color: 'var(--foreground)',
      }}
    >
      <Link
        to="/account"
        role="menuitem"
        data-testid="menu-item-my-account"
        onClick={onClose}
        className="flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors duration-100 hover:bg-[var(--background-muted)]"
      >
        <span className="material-symbols-outlined text-[16px]" aria-hidden="true">person</span>
        {t('nav.myAccount')}
      </Link>
    </div>
  );
}
